import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TrendingUp, Activity, Boxes, BookOpen } from 'lucide-react';
import { useEquitiesMode } from '../hooks/useEquitiesMode';

const ALL_LINKS = [
  { base: '/trade/stocks', to: '/trade/stocks/overview', label: 'Stocks', icon: TrendingUp },
  { base: '/trade/crypto', to: '/trade/crypto/overview', label: 'Crypto', icon: Activity },
  { base: '/trade/forex', to: '/trade/forex/overview', label: 'Forex', icon: Boxes },
  { base: '/trade/futures', to: '/trade/futures/overview', label: 'Futures', icon: BookOpen },
] as const;

/** Sprint 8 — quick vertical switcher on small screens. */
export const MobileTradeDock: React.FC = () => {
  const { pathname } = useLocation();
  const { equities_only: equitiesOnly } = useEquitiesMode();
  if (!pathname.startsWith('/trade/')) return null;

  const links = equitiesOnly ? ALL_LINKS.filter((l) => l.base === '/trade/stocks') : [...ALL_LINKS];
  if (links.length <= 1) return null;

  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 px-1 py-1.5 safe-area-pb">
      <nav className="flex justify-around items-center max-w-lg mx-auto" aria-label="Trade verticals">
        {links.map(({ base, to, label, icon: Icon }) => {
          const on = pathname.startsWith(base);
          return (
            <Link
              key={to}
              to={to}
              className={`flex flex-col items-center gap-0.5 px-2 py-1 rounded-md text-[10px] font-medium ${
                on ? 'text-primary bg-primary/10' : 'text-muted-foreground'
              }`}
            >
              <Icon className="w-5 h-5" />
              {label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default MobileTradeDock;
